import { useState, useEffect } from 'react';
import { db } from '../firebase/config';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { useApp } from '../context/AppContext';

const MIN_AGE_DAYS = 5;
const ROLL_AGE_DAYS = 9;

// Real week-over-week trend, not fabricated. Keeps a rolling snapshot of mastery %
// per subject; once the snapshot is 5+ days old we have an honest "vs last week"
// comparison, and once it's 9+ days old we roll the anchor forward so it stays
// roughly weekly instead of drifting indefinitely.
export default function useMasteryTrend(subjectId) {
  const { user } = useAuth();
  const { getSubjectProgress } = useApp();
  const [trend, setTrend] = useState(null);
  const currentPct = getSubjectProgress(subjectId).pct;

  useEffect(() => {
    if (!user?.uid || !subjectId) return;
    let cancelled = false;
    (async () => {
      try {
        const ref = doc(db, 'masterySnapshots', `${user.uid}_${subjectId}`);
        const snap = await getDoc(ref);
        const now = Date.now();
        if (!snap.exists()) {
          await setDoc(ref, { userId: user.uid, subjectId, pct: currentPct, date: new Date().toISOString() });
          return;
        }
        const data = snap.data();
        const ageDays = (now - new Date(data.date).getTime()) / 86400000;
        if (ageDays >= MIN_AGE_DAYS && !cancelled) {
          const delta = currentPct - data.pct;
          setTrend({ delta: Math.abs(Math.round(delta)), direction: delta >= 0 ? 'up' : 'down' });
        }
        if (ageDays >= ROLL_AGE_DAYS) {
          await setDoc(ref, { userId: user.uid, subjectId, pct: currentPct, date: new Date().toISOString() });
        }
      } catch (err) {  }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.uid, subjectId]);

  return trend;
}
